import { Button, Dialog } from '@mui/material'
import { useReactToPrint } from "react-to-print";
import { useRef } from 'react'
import Proptypes from 'prop-types'
import BarcodeSection from './molecules/BarcodeSection';

function BarcodeModal({ closeModal, codigoProducto, UserId, open, descripcion }) {
    const codigoRef = useRef(null)

    const handlePrint = useReactToPrint({ content: () => codigoRef.current });
    return (
        <Dialog maxWidth='md' onClose={closeModal} open={open}>
            <BarcodeSection ref={codigoRef} codigoProducto={codigoProducto} UserId={UserId} descripcion={descripcion} />
            <Button color='primary' variant='contained' component='span' onClick={handlePrint}>
                Imprimir
            </Button>
        </Dialog >
    )
}

BarcodeModal.propTypes = {
    closeModal: Proptypes.func,
    codigoProducto: Proptypes.string,
    UserId: Proptypes.string,
    open: Proptypes.bool,
    descripcion:Proptypes.string,
}

export default BarcodeModal;